<template>
    <component
        :is="is"
    >
        <slot />
    </component>
</template>

<script>
import { container } from '@/js/util/carousel';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'CarouselContainer',
    defaultTag: 'div',
    mixins: [dynamicComponent],
    provide() {
        return {
            [container]: this,
        };
    },
    props: {
        transitionName: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            items: [],
            activeItem: undefined,
        };
    },
    created() {
        this.$on('createdItem', this.createdItem);
        this.$on('moveActiveItem', this.moveActiveItem);
        this.$on('updateActiveItem', this.updateActiveItem);
        this.$on('beforeDestroyItem', this.beforeDestroyItem);
    },
    beforeDestroy() {
        this.$off('createdItem', this.createdItem);
        this.$off('moveActiveItem', this.moveActiveItem);
        this.$off('updateActiveItem', this.updateActiveItem);
        this.$off('beforeDestroyItem', this.beforeDestroyItem);
    },
    methods: {
        createdItem(item) {
            this.items.push(item);

            if (!this.activeItem) {
                this.activeItem = item;
            }
        },
        beforeDestroyItem(item) {
            const { items } = this;

            items.splice(items.indexOf(item), 1);
        },
        moveActiveItem(vector) {
            const activeIndex = this.items.indexOf(this.activeItem);
            let newActiveIndex = (activeIndex + vector) % this.items.length;

            if (newActiveIndex < 0) {
                newActiveIndex += this.items.length;
            }

            this.activeItem = this.items[newActiveIndex];
        },
        updateActiveItem(item) {
            this.activeItem = item;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/carousel/CarouselContainer.vue